import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { AuditorVisitDetail } from '../types';
import env from '@/env';

export const getAuditorVisitById = async (
  id: string,
  lang: string
): Promise<AuditorVisitDetail> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-visits/${id}?${new URLSearchParams({
      lang,
    })}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditorVisitDetail;
  return response;
};
